/* eslint-disable */
import React, { useContext, useState } from 'react';
import { Grid, Paper } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/authContext';
import {
  forgotHeaderStyle,
  labelStyle,
  paperStyle,
  pLabelDarkerStyle,
  pLabelStyle,
} from '../styles';
import { Typography } from '@mui/material';
import { AuthPAGES } from '../../constants/pages';
import { PAGES } from '../../../../types/pages';
import { Header } from './components/Header/Header';
import { MuiButton } from '../../components/Button/Button';

const EmailSent: React.FC<any> = () => {
  /* States and context declaration */
  const authContext = useContext(AuthContext);
  const { email } = authContext;
  const navigate = useNavigate();

  const [genericErrorMessage, setGenericErrorMessage] = useState('');
  const onRecoverPressed = async (e: any) => {
    e.stopPropagation();
    if (email) {
      try {
        await authContext.sendCodeRecoverPassword(email);
      } catch (error: any) {
        setGenericErrorMessage(error.message);
      }
    }
  };

  return (
    <Grid container justifyContent='center' alignContent='center'>
      <Grid item xl={4} lg={4} md={5} sm={6} xs={12}>
        <Paper elevation={1} style={paperStyle}>
          <Grid item xs={12} md={12} xl={12} style={forgotHeaderStyle}>
            <Header email={email} />
          </Grid>
        </Paper>
        <Grid
          item
          xs={12}
          md={12}
          xl={12}
          style={{ ...labelStyle, marginTop: '40px' }}
        >
          <Typography style={{ ...pLabelDarkerStyle, color: 'white' }}>
            Did not receive the email? Check your spam filter or
            <Link
              to=''
              onClick={onRecoverPressed}
              style={{ ...pLabelStyle, marginLeft: '5px', color: 'white' }}
            >
              Send link again
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmailSent;
